/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import ClickableIcon from '../../../components/ClickableIcon';
import IconTrash from '../../../components/icons/IconTrash';

interface Props {
  onClick(): void;
}
const TrashShareCardButton: React.FC<Props> = (props) => (
  <ClickableIcon align="right" onClick={props.onClick}>
    <IconTrash.Medium color="dark-neutral" />
  </ClickableIcon>
);

export default TrashShareCardButton;
